'use strict';
exports.f = Object.defineProperty;
